import React from "react";
import { parseDateString } from "util/dateHelper";
import SortableTable from "components/SortableTable";
import ButtonCell from "./cells/ButtonCell";
import { Meet, RefDetails } from "types";
import toLower from "lodash/toLower";
import get from "lodash/get";
import size from "lodash/size";
import { Column } from "components/table/Table";
import { useMediaSize } from "util/useMediaSize";
import InputCell from "./cells/InputCell";

const RefsTable = ({
  meet,
  refs,
}: {
  meet: Meet;
  refs: Record<string, RefDetails>;
}) => {
  const media = useMediaSize();
  const getAllColumns = (): Column[] => {
    const columns: Column[] = [
      {
        key: "",
        label: "",
        width: 45,
        renderer: ButtonCell,
      },
      {
        key: "name",
        label: "Ref Name",
        width: 200,
        type: "text",
        sortable: true,
        sortFunction: (row: any) => toLower(row.name),
        sortDirection: "asc",
        sortOrder: 1,
        renderer: InputCell,
      },
      {
        key: "birthDate",
        label: "Ref DOB",
        width: 160,
        type: "date",
        sortable: true,
        sortFunction: (row: any) =>
          parseDateString({ dateString: row.birthDate, meet: meet }),
        sortDirection: "asc",
        sortOrder: 2,
        renderer: InputCell,
      },
      {
        key: "state",
        label: "Ref State",
        width: 160,
        type: "text",
        sortable: true,
        sortDirection: "asc",
        sortOrder: 3,
        renderer: InputCell,
      },
      {
        key: "memberId",
        label: "Ref MemberID",
        width: 160,
        type: "text",
        sortable: true,
        sortDirection: "asc",
        sortOrder: 4,
        renderer: InputCell,
      },
      {
        key: "chief",
        label: "Chief",
        width: 100,
        type: "checkbox",
        sortable: true,
        sortDirection: "asc",
        sortOrder: 5,
        renderer: InputCell,
      },
      {
        key: "side",
        label: "Side",
        width: 100,
        type: "checkbox",
        sortable: true,
        sortDirection: "asc",
        sortOrder: 6,
        renderer: InputCell,
      },
      {
        key: "weighIn",
        label: "Weigh-In",
        width: 100,
        type: "checkbox",
        sortable: true,
        sortDirection: "asc",
        sortOrder: 7,
        renderer: InputCell,
      },
      {
        key: "doping",
        label: "Doping",
        width: 100,
        type: "checkbox",
        sortable: true,
        sortDirection: "asc",
        sortOrder: 8,
        renderer: InputCell,
      },
      {
        key: "technicalSecretary",
        label: "Technical Secretary",
        width: 160,
        type: "checkbox",
        sortable: true,
        sortDirection: "asc",
        sortOrder: 9,
        renderer: InputCell,
      },
      {
        key: "technicalController",
        label: "Technical Controller",
        width: 160,
        type: "checkbox",
        sortable: true,
        sortDirection: "asc",
        sortOrder: 10,
        renderer: InputCell,
      },
      {
        key: "jury",
        label: "Jury",
        width: 100,
        type: "checkbox",
        sortable: true,
        sortDirection: "asc",
        sortOrder: 11,
        renderer: InputCell,
      },
      {
        key: "scoring",
        label: "Scoring",
        width: 100,
        type: "checkbox",
        sortable: true,
        sortDirection: "asc",
        sortOrder: 12,
        renderer: InputCell,
      },
      {
        key: "equipmentCheck",
        label: "Equipment Check",
        width: 150,
        type: "checkbox",
        sortable: true,
        sortDirection: "asc",
        sortOrder: 13,
        renderer: InputCell,
      },
      {
        key: "meetDirector",
        label: "Meet Director",
        width: 130,
        type: "checkbox",
        sortable: true,
        sortDirection: "asc",
        sortOrder: 14,
        renderer: InputCell,
      },
    ];

    return columns;
  };

  const getCellLines = (index: number, lifters: any) => {
    const rows = size(get(lifters, [index, "divisions"], 1));
    if (rows === 0) {
      return 1;
    }

    return rows * 1.085;
  };

  return (
    <SortableTable
      data={refs}
      columns={getAllColumns()}
      getCellLines={getCellLines}
      meet={meet}
      numberOfFixedLeftColumns={2}
      media={media}
    />
  );
};

export default RefsTable;
